<app-modal-header (closeModal)="modal.close()">
  {{ 'Reviews.AddReview' | translate }}
</app-modal-header>
<app-post-review-form
  *ngIf="hotelId$ | async as hotelId"
  [destinationId]="hotelId"
  [destinationType]="hotelDestination"
  (posted)="modal.close()">
</app-post-review-form>
